// extracted by mini-css-extract-plugin
export default {"schedule":"Schedule_schedule__CEGmc","title":"Schedule_title__t-eZN","tableWrap":"Schedule_tableWrap__0vMed","btn":"Schedule_btn__a8IJ0"};